export const FETCH_MARKERS_REQUEST = "fetch/markers/request";
export const FETCH_MARKERS_SUCCESS = "fetch/markers/success";
export const FETCH_MARKERS_FAILURE = "fetch/markers/failure";
export const FETCH_MARKER_REQUEST = "fetch/marker/request";
export const FETCH_MARKER_SUCCESS = "fetch/marker/success";
export const FETCH_MARKER_FAILURE = "fetch/marker/failure";
export const UPDATE_MARKER_REQUEST = "update/marker/request";
export const UPDATE_MARKER_SUCCESS = "update/marker/success";
export const UPDATE_MARKER_FAILURE = "update/marker/failure";
export const CREATE_MARKER_REQUEST = "create/marker/request";
export const CREATE_MARKER_SUCCESS = "create/marker/success";
export const CREATE_MARKER_FAILURE = "create/marker/failure";
export const DELETE_MARKER_REQUEST = "delete/marker/request";
export const DELETE_MARKER_SUCCESS = "delete/marker/success";
export const DELETE_MARKER_FAILURE = "delete/marker/failure";
export const DELETE_AND_MERGE_MARKER_REQUEST =
  "delete/and/merge/marker/request";
export const DELETE_AND_MERGE_MARKER_SUCCESS =
  "delete/and/merge/marker/success";
export const DELETE_AND_MERGE_MARKER_FAILURE =
  "delete/and/merge/marker/failure";
